module.exports = __webpack_public_path__ + "files/4962318b9c0bf07295fbd7d1fc75abb6.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/exo2-bold-webfont.eot
 ** module id = 404
 ** module chunks = 0
 **/